import axios from "axios";


const BASE_URL= 'https://youtube-v31.p.rapidapi.com';
const options = {
 
  url:BASE_URL,
  params: {
  
    maxResults: '50',
   
  },
  headers: {
    'X-RapidAPI-Key':'2c77d51150msh1377c85d90bb00dp17c177jsncbf7c69076c5',
    'X-RapidAPI-Host': 'youtube-v31.p.rapidapi.com'
  }
};
export const fetchFromAPI=async (url)=>{
     const {data}= await axios.get(`${BASE_URL}/${url}`, options)
     return data;
}